// src/pages/Login/ResetPassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleLogin = () => {
    navigate("/login");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/users/reset-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || 'Request failed');
      } else {
        setMessage(data.message || 'Reset instructions sent');
      }
    } catch (err) {
      setError('Request failed. Please try again.');
      console.error('Error:', err);
    }
  };

  return (
    <section className="login">
      <style>{`header { display: none; }`}</style>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className="login-graphic middle center">
              <img src="/images/Logo.svg" alt="Logo" />
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 first-xs last-sm">
            <div className="login-form middle center">
              <form onSubmit={handleSubmit}>
                <h5 className="text-center">Reset Password</h5>
                {error && <p className="fail">{error}</p>}
                {message && <p className="success">{message}</p>}
                <div className="text-uppercase margin-top-l">Email</div>
                <input 
                  type="email" 
                  name="Email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
                <div className="form-footer margin-top-l middle">
                  <button 
                    type="button" 
                    className="text-link"
                    onClick={handleLogin}
                  >
                    or log in here
                  </button>
                  <button type="submit" data-value="question form">Send Request</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
